import { ButtonElement } from "appworks/graphics/elements/button-element";
import { AbstractControl } from "appworks/ui/controls/abstract-control";

export class EpicHistoryButtonControl extends AbstractControl {

    constructor(protected button: ButtonElement) {
        super();
        button.visible = false;
    }
}
